import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalOptionsService extends BaseService {
  protected override baseURL = 'v1/global-options';
  private http = inject(HttpClient);

  private configCache = new Map<string, string>();

  async getGlobalOption(key: string): Promise<string> {
    if (this.configCache.has(key)) {
      return this.configCache.get(key)!;
    }

    // We use HttpClient to guarantee reading text safely in case the backend returns unquoted string
    // formatRoute prepares the path using the apiS base URL.
    let url = this.apiS.baseURL + '/' + this.baseURL + '/' + key;
    // ensure no double slashes anywhere (except the protocol)
    url = url.replace(/([^:]\/)\/+/g, '$1');
    const res = await lastValueFrom(this.http.get(url, { responseType: 'text' }));

    this.configCache.set(key, res);
    return res;
  }
}
